/**
 * Source des articles du fil News.
 *
 * L'ORIGINE EST ICI, pas dans l'écran ni dans le service : c'est la seule valeur qui change entre
 * un environnement et un autre, et la chercher dans un composant de 400 lignes le jour où il faudra
 * pointer une préproduction est exactement le genre de recherche qu'on ne devrait pas avoir à faire.
 *
 * Même API publique que l'encart de l'accueil (`src/services/content.ts`) : ni clé, ni jeton, CORS
 * ouvert, réponses mises en cache dix minutes par le CDN. Aucun quota n'est décompté — ce n'est pas
 * un appel IA, et un échec ne coûte rien à l'utilisateur.
 *
 * Conséquence à connaître, identique à celle de l'accueil : l'IP de l'appareil atteint l'hébergeur
 * du site à chaque ouverture de l'onglet. alternjob.com est notre propre site ; son HÉBERGEUR est un
 * sous-traitant déclaré au § 5 de la politique de confidentialité.
 */
export const NEWS_API_ORIGIN = 'https://alternjob.com';

export const NEWS_ARTICLES_PATH = '/api/articles';

/**
 * Base de lecture d'un article sur le site. L'API NE RENVOIE PAS D'URL : elle se construit depuis
 * le slug, exactement comme le fait déjà `services/content.ts` pour l'encart de l'accueil. Le
 * sous-domaine `www` est celui que sert le site pour les pages publiques.
 */
export const ARTICLE_BASE_URL = 'https://www.alternjob.com/blog';

/**
 * Taille de page. TOUJOURS transmise, dès la première requête : sans `limit`, l'API renvoie tout
 * d'un bloc, non paginé, et SANS `pageInfo`. Le fil se retrouverait alors sans curseur et sans
 * moyen de savoir s'il reste quelque chose — pagination silencieusement désactivée.
 */
export const NEWS_PAGE_SIZE = 10;

/**
 * Plafond de pages chargées.
 *
 * Garde-fou, pas une limite produit : l'API se comporte bien aujourd'hui, mais un curseur qui
 * tournerait en rond côté serveur ferait défiler l'application jusqu'à épuisement de la mémoire.
 * Cinquante pages font cinq cents articles, très au-delà du fil réel.
 */
export const NEWS_MAX_PAGES = 50;

/** Coupe un appel qui n'aboutit pas : le fil affiche une erreur réessayable, il n'attend pas. */
export const NEWS_TIMEOUT_MS = 8000;
